<template>
    <div class="challenge-item challenge-item-bg closed" v-if="challenge.status == 0">
        <div class="row-1 m-b23">
            {{ challenge.key_open }} <i class="ito-icon-lock"></i>
        </div>
        <div class="row-2">
            <i class="ito-icon-box-close"></i>
        </div>
        <div class="row-3 m-t10">
            <button class="btn btn-ito-2" disabled>
                {{ $t('claim') }}
            </button>
        </div>
    </div>
    <div class="challenge-item challenge-item-bg closed" v-else-if="challenge.status == 1">
        <div class="row-1 m-b23">
            {{ challenge.key_open }} <i class="ito-icon-lock"></i>
        </div>
        <div class="row-2">
            <i class="ito-icon-box-close"></i>
        </div>
        <div class="row-3 m-t10">
            <button class="btn btn-ito-2" @click="claim">
                {{ $t('claim') }}
            </button>
        </div>
    </div>
    <div class="challenge-item opened" v-else-if="challenge.status == 2 || challenge.status == 3">
        <div class="row-1 m-b12">
            {{ challenge.key_open }} <i class="ito-icon-lock-black"></i>
        </div>
        <div class="row-2">
            <i class="ito-icon-box-opened"></i>
        </div>
        <div class="row-3"></div>
    </div>
    <div class="challenge-item disabled" v-else-if="challenge.status == 4">
        <div class="row-1 m-b12">
            {{ challenge.key_open }} <i class="ito-icon-lock-black"></i>
        </div>
        <div class="row-2">
            <i class="ito-icon-box-disabled"></i>
        </div>
        <div class="row-3"></div>
    </div>
</template>

<script>
import { mapGetters } from 'vuex'
import axios from "axios";
import { authLogin } from "../../models/auth";
import { claimChestDailyChallenge } from "../../models/reward";
import { soundClick, soundGetReward, soundClaimKey } from '../../utils/utils';

export default {
    name: "DailyChallengeItem",

    props: ['challenge'],

    data() {
        return {};
    },

    computed: {
        ...mapGetters([
            'user_info'
        ], () => {
            if (this.user_info) {
                return this.user_info
            }

            return {
                gem: 0
            }
        })
    },

    created() {

    },

    methods: {
        claim() {
            const that = this;

            that.getSoundClick();
            claimChestDailyChallenge({
                id: that.challenge.id,
                //is_raw: true
            }).then((response) => {
                if (response.data.code != 0) {
                    return;
                }

                const new_gem = response.data.results.update_gem || 0;
                const new_key_collect = response.data.results.key_collect || 0;
                const new_challenges = response.data.results.challenge || [];
                const gem_reward = response.data.results.gem_reward || [];

                that.user_info.dailychallenge_noti = response.data.results.dailychallenge_noti || 0;

                //const gem = new_gem - that.user_info.gem;

                that.user_info.gem = new_gem;
                const gem_txt = gem_reward > 0 ? '+' + gem_reward : gem_reward;

                this.$emit('updateNewChallenge', new_challenges, new_key_collect, gem_txt)

                // $('#congratulation_gem').text(gem_txt);

                // // that.getSoundGetReward();
                // that.getSoundClaimKey();

                // $('#getRewardedModal').modal('show');

                //$("#getRewardedModal").on('hide.bs.modal', function(){
                //    location.reload();
                //});
            }).catch(({ response }) => {
                console.error(response);
            });
        },

        getSoundClick() {
            soundClick();
        },

        getSoundGetReward() {
            soundGetReward();
        },

        getSoundClaimKey() {
            soundClaimKey();
        },
    }
}
</script>

<style scoped></style>
